// Centralised site data for IVrenovation

export const COMPANY = {
  name: "IVrenovation",
  tagline: "Renovation & Construction, built with precision.",
  whatsapp: "https://wa.me/14374507171",
  phone: "+1 (437) 450-7171",
  email: "IVrenovationandcon@gmail.com",
  address: "Durham Region & GTA, ON",
  hours: "Mon–Sat · 7:00 AM — 6:00 PM",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    slug: "tile-work",
    title: "Tile Work",
    summary: "Precision tile installation for floors, walls, bathrooms, and kitchens.",
    details: [
      "Ceramic, porcelain, marble & natural stone",
      "Waterproofing for wet areas",
      "Mosaic & large-format tile expertise",
    ],
    icon: "LayoutGrid",
    image: "https://images.pexels.com/photos/11806489/pexels-photo-11806489.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "bathroom-renovation",
    title: "Bathroom Renovation",
    summary: "Full bathroom remodels — from demolition to final finish.",
    details: [
      "Custom shower & vanity builds",
      "Plumbing rough-in coordination",
      "Luxury finishes & spa-grade fixtures",
    ],
    icon: "Bath",
    image: "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjB0aWxlfGVufDB8fHx8MTc4MjI2OTg0Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "kitchen-renovation",
    title: "Kitchen Renovation",
    summary: "Modern kitchens engineered for daily life.",
    details: [
      "Cabinetry & countertop installs",
      "Backsplash & lighting design",
      "Open-concept reconfigurations",
    ],
    icon: "ChefHat",
    image: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3IlMjBkZXNpZ24lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgyMjY5ODQzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "painting",
    title: "Painting",
    summary: "Flawless interior & exterior finishes.",
    details: [
      "Color consultation",
      "Premium low-VOC paints",
      "Drywall prep & priming",
    ],
    icon: "Paintbrush",
    image: "https://images.unsplash.com/photo-1688372199140-cade7ae820fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxob3VzZSUyMHBhaW50ZXIlMjB3b3JraW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgyMjY5ODU5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "flooring",
    title: "Flooring",
    summary: "Hardwood, LVP, laminate, and engineered floors.",
    details: [
      "Subfloor leveling",
      "Herringbone & pattern layouts",
      "Trim & transitions",
    ],
    icon: "Rows3",
    image: "https://images.unsplash.com/photo-1722605090433-41d1183a792d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3IlMjBkZXNpZ24lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgyMjY5ODQzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "electrical",
    title: "Electrical Work",
    summary: "Wiring, fixtures, and panel upgrades.",
    details: [
      "Recessed lighting",
      "Outlet & switch installation",
      "Code-compliant rewiring",
    ],
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "drywall",
    title: "Drywall",
    summary: "Hanging, taping, and Level-5 smooth finishes.",
    details: [
      "Patch & repair",
      "Soundproof assemblies",
      "Texture matching",
    ],
    icon: "SquareStack",
    image: "https://images.unsplash.com/photo-1694522362256-6c907336af43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBjcmFmdHNtYW4lMjB3b3JraW5nfGVufDB8fHx8MTc4MjI2OTg0Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "carpentry",
    title: "Carpentry",
    summary: "Custom trim, framing, and built-ins.",
    details: [
      "Crown moulding & baseboards",
      "Custom shelving",
      "Door & window installs",
    ],
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBjcmFmdHNtYW4lMjB3b3JraW5nfGVufDB8fHx8MTc4MjI2OTg0Mnww&ixlib=rb-4.1.0&q=85",
  },
];

export const GALLERY = [
  {
    id: "g1",
    title: "Marble Master Bath",
    category: "Bathrooms",
    image: "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjB0aWxlfGVufDB8fHx8MTc4MjI2OTg0Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g2",
    title: "Freestanding Tub Suite",
    category: "Bathrooms",
    image: "https://images.unsplash.com/photo-1521783593447-5702b9bfd267?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjB0aWxlfGVufDB8fHx8MTc4MjI2OTg0Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g3",
    title: "Large-Format Floor Tile",
    category: "Tile",
    image: "https://images.pexels.com/photos/11806489/pexels-photo-11806489.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "g4",
    title: "Vanity & Mirror Wall",
    category: "Bathrooms",
    image: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjB0aWxlfGVufDB8fHx8MTc4MjI2OTg0Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g5",
    title: "White Cabinet Kitchen",
    category: "Kitchens",
    image: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3IlMjBkZXNpZ24lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgyMjY5ODQzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g6",
    title: "Architectural Kitchen Reno",
    category: "Kitchens",
    image: "https://images.unsplash.com/photo-1722605090433-41d1183a792d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3IlMjBkZXNpZ24lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgyMjY5ODQzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g7",
    title: "Interior Painting Project",
    category: "Painting",
    image: "https://images.unsplash.com/photo-1688372199140-cade7ae820fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxob3VzZSUyMHBhaW50ZXIlMjB3b3JraW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgyMjY5ODU5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g8",
    title: "Framing & Carpentry",
    category: "Construction",
    image: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBjcmFmdHNtYW4lMjB3b3JraW5nfGVufDB8fHx8MTc4MjI2OTg0Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g9",
    title: "Detail Grinding",
    category: "Construction",
    image: "https://images.unsplash.com/photo-1694522362256-6c907336af43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBjcmFmdHNtYW4lMjB3b3JraW5nfGVufDB8fHx8MTc4MjI2OTg0Mnww&ixlib=rb-4.1.0&q=85",
  },
];

export const GALLERY_CATEGORIES = ["All", "Bathrooms", "Kitchens", "Tile", "Painting", "Construction"];

export const PROCESS = [
  { step: "01", title: "Consultation", body: "We listen to your vision and walk the space together." },
  { step: "02", title: "Design & Quote", body: "Material selections, drawings, and a transparent fixed quote." },
  { step: "03", title: "Build", body: "Skilled craftsmen, daily site cleanup, weekly progress reports." },
  { step: "04", title: "Walkthrough", body: "Final QA punch-list and a thorough handover of your finished space." },
];
